import type { PotentialEmissionsBasisPeriod } from '../../types/release-profiles.ts';

export function potentialBasisPeriodHours(period: PotentialEmissionsBasisPeriod): number {
  const hoursPerUnit = { hour: 1, day: 24, month: 730, year: 8760 } as const;
  return period.count * hoursPerUnit[period.unit];
}

/** How a basis period reads next to a cap, as in "50 tons / 1 year". */
export function potentialBasisPeriodLabel(period: PotentialEmissionsBasisPeriod): string {
  return `${period.count} ${period.unit}${period.count === 1 ? '' : 's'}`;
}
